module.exports = __webpack_public_path__ + "img/section4_img.fe42a1d2.svg";